import { Controller } from "@hotwired/stimulus"
import { loadRecaptcha } from "../helpers/recaptcha_loader"

export default class RecaptchaController extends Controller {
  static targets = ["token"]
  static values = { siteKey: String, action: String }

  #resubmitting = false

  async generateToken(event) {
    if (!this.hasTokenTarget) return
    if (this.#resubmitting) return

    event.preventDefault()
    event.submitter.disabled = true

    try {
      const grecaptcha = await loadRecaptcha(this.siteKeyValue)
      this.tokenTarget.value = await grecaptcha.execute(this.siteKeyValue, {
        action: this.actionValue,
      })
    } catch (error) {
      this.tokenTarget.value = ""
    }

    event.submitter.disabled = false
    this.#resubmitting = true
    this.element.requestSubmit()
    this.#resubmitting = false
  }
}
